$(function(){

    //recommendation module
    var questions = [],
        questionIndex = 0,
        //product filter tags
        include = [],
        exclude =[];

    var pathIndex = 0;

    var paths = [
        [1,2,3,5], //q1 = no
        [1,2,3,4,5], //q1 = yes, q2 = yes
        [1,2,3,4,5] //q1 = yes, q2 = no
      ];

    var optionals = ['reco-sweet','reco-floral','reco-earthy','reco-high','reco-low'];


    function Question( element ) {
      this.element = $(element);
      this.requiresAnswer = !this.element.hasClass('mailchimp');
      this.answers = [];
      this.answered = false;
      this.includeTags = [];
      this.excludeTags = [];

      this.css = [{
        'beforeShow': 'before-show-left',
        'hide': 'hide-right'
      },{
        'beforeShow': 'before-show-right',
        'hide': 'hide-left'
      }];

      this.setup();
    }

    Question.prototype.setup = function() {
      this.value = null;
      this.id = this.element.data('id');

      this.events();

    };

    Question.prototype.getAllClasses = function() {
    	var css = ['active'];

    	for ( var i = 0, len = this.css.length; i < len; i++ ) {
    		css.push( this.css[ i ].beforeShow, this.css[ i ].hide );
    	}

    	return css.join(' ');
    };

    Question.prototype.events = function() {
      this.element.find('.answer').on('click', this.answer.bind(this) );
    };

    Question.prototype.hide = function( direction ) {
      this.element.removeClass( this.getAllClasses() ).addClass( this.css[ direction ].hide );
    };

    Question.prototype.show = function( direction ) {
      this.element.removeClass( this.getAllClasses() ).addClass( this.css[ direction ].beforeShow );

      window.setTimeout(function(){
        this.element.addClass('active');
      }.bind(this),100);
    }

    Question.prototype.answer = function( e ) {
      e.preventDefault();
      var answer = $(e.currentTarget);

      //remove active state from all answers
      this.element.find('.answer').removeClass('selected');

      //add active state to selected answer
      answer.addClass('selected');

      //store the value of the selected answer
      this.value = answer.data('val');

      //store the include tags for this answer
      this.includeTags = answer.data('include').split(',');

      //store the exclude tags for this answer
      this.excludeTags = answer.data('exclude').split(',');

      //this question has been answered
      this.answered = true;

      //fire question answered on survey logic app
      questionAnswered();

    };


    function setup() {

      $('.tsrq').each(function() {
        questions.push( new Question( this ) );
      });

      $('.tsrq').addClass('hide-right');

      // console.log( questions );

      if ( $('.tsrq').length > 0 ) {
          events();
      }

    }

    function submitMailchimp( $form ) {
        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize(),
          cache       : false,
          dataType    : 'json',
          contentType: 'application/json; charset=utf-8',
          error       : function(err) { console.log('Could not connect to the registration server. Please try again later.'); },
          success     : function(data) {
              if (data.result != 'success') {
                  // Something went wrong, do something to notify the user. maybe alert(data.msg);
                  console.log(data.msg);
              } else {
                  // It worked, carry on...
                  console.log('mailchimp success');
              }
          }
      });
    }

    function validateMailchimpForm( $form ) {
      if ( $form.find('input.mce_inline_error').length === 0 && $form.find('.email').val() !== '' ) {
        return true;
      }

      return false;
    }

    function events() {

      $('.tsrq-next').on('click', function( e ) {
        e.preventDefault();

        var question = $(this).closest('.tsrq');

        if ( question.hasClass('mailchimp') ) {
          var $form = $('.tsrq-mailchimp-subscribe');
          if ( validateMailchimpForm( $form ) ) {
            //if there are no mailchimp form errors submit the form and move on.
            question.removeClass('showing-error');
            submitMailchimp( $form );
            next();
          } else {
            question.addClass('showing-error');
          }
        } else if ( question.find('.answer.selected').length > 0 ) {
          question.removeClass('showing-error');
          next();
        } else {
          question.addClass('showing-error');
          //show msg
        }




      });

      $('.start-quiz').on('click', function( e ) {
        e.preventDefault();

        reset();
        start();
      });

    }

    function setTags() {
      include = [];
      exclude = [];

      for ( var i = 0; i < questions.length; i++ ) {

        var q = questions[ i ];

        //if this question has been answered set the include and exclude tags
        if ( q.answered ) {
          include = include.concat( q.includeTags );
          exclude = exclude.concat( q.excludeTags );
        }

      }
    }

    function questionAnswered() {
      setTags();
      setPath();
    }

    function setPath() {

      if ( questions[0].answered && questions[0].value == 0 ) {
        pathIndex = 0;
      } else if (questions[0].answered && questions[0].value == 1 && !questions[1].answered ) {
        pathIndex = 1;
      } else if ( questions[0].answered && questions[0].value == 1 && questions[1].answered && questions[1].value == 1 ) {
        //yes caffeine, yes flavors
        pathIndex = 1;
      } else if ( questions[0].answered && questions[0].value == 1 && questions[1].answered && questions[1].value == 0  ) {
        pathIndex = 2;
      }

      console.log('path selected: ' + pathIndex, paths[ pathIndex ] );

    }

    function calculateProgress() {
      var current = 0;
      for ( var i = 0; i < questions.length; i++ ) {
        if ( questions[ i ].answered == 1 ) {
          current = i;
        }
      }

      var progress = (current + 1) / paths[ pathIndex ].length;

      console.log( 'current question: ' + current,'path: ', paths[ pathIndex ], progress, questionIndex );

      $('.tsrq-progress-indicator').css('width', (progress * 100) + '%' );
    }

    function getNextQuestion() {

    }

    function isOptional( tag ) {
      var i = optionals.length;

      return false;

      while ( i-- ) {
        if ( optionals[ i ].toLowerCase() === tag.toLowerCase() ) {
          return true;
        }
      }

      return false;
    }

    function next() {

      questions[ questionIndex ].hide(1);

      //get next question
      questionIndex++;// = questionIndex + 1 < paths[ pathIndex ].length ? questionIndex + 1 : questionIndex;

      if ( questionIndex === paths[ pathIndex ].length ) {

        calculateProgress();
        finish();

      } else {

        //get next question id
        var nextQuestionID = paths[ pathIndex ][ questionIndex ];

        var nextQuestion = getQuestion( nextQuestionID );

        pause(function(){ nextQuestion.show(1); }, 500 );

        //show progress
        calculateProgress();

      }


    }

    function prev() {

    }

    function contains(haystack, needle) {
      for ( var i = 0; i < haystack.length; i++ ) {
        if ( haystack[ i ].toLowerCase() === needle.toLowerCase() ) {
          return true;
        }
      }
      return false;
    }

    function filterTeas() {

      $('.reco-product').each(function(){

        var productTags = $(this).data('tags').split(','),
            recommeding = true;

        // console.log('include tags:', include);
        // console.log('product tags:', productTags);

        //check to see if this product has all the include tags
        for ( var i = 0; i < include.length; i++ ) {
            if ( !contains(productTags, include[ i ] ) && !isOptional( include[ i ] ) ) {
              recommeding = false;
            }
        }

        for ( var j = 0; j < exclude.length; j++ ) {
          if ( contains(productTags, exclude[ j ]) ) {
            recommeding = false;
          }
        }

        console.log( 'recommeding tea: ', recommeding );

        if ( recommeding ) {
          $(this).addClass('recommeding');
        } else {
          $(this).addClass('excluding');
        }

      });

    }

    function scrubTags() {
      var i = include.length;

      while ( i-- ) {
        if ( include[ i ] === '' ) {
          include.splice(i,1);
        }
      }

      var e = exclude.length;

      while ( e-- ) {
        if ( exclude[ e ] === '' ) {
          exclude.splice( e , 1);
        }
      }

    }

    function finish() {

      //filter tea list or query products
      // console.log('done. showing teas');
      // console.log('tags to include:', include );
      // console.log('tags to exclude:', exclude );

      $('.reco-module').addClass('getting-results');

      scrubTags();
      filterTeas();

      //show the teaList
      pause(function() {
          showMatchingTeas();
      },2000);

    }

    function showMatchingTeas() {
      console.log('showing matching teas');
      $('.reco-module').removeClass('getting-results');
      $('.reco-module').addClass('showing-results');
    }

    function getQuestion( id ) {
      for ( var i = 0; i < questions.length; i++ ) {
        if ( questions[ i ].id == id ) {
          return questions[ i ];
        }
      }
      return null;
    }

    function start() {
      $('.ts-quiz').addClass('started');
      var nextQuestion = paths[ pathIndex ][ questionIndex ];
      $('.tsrq[data-id=' + nextQuestion + ']').addClass('active');
    }

    function reset() {

    }

    function pause( callback, duration ) {
      return window.setTimeout(callback,duration);
    }

    setup();


});
